import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2ed7d4f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "keyItemsWrapper" }
const _hoisted_3 = { class: "content" }

import { useI18n } from 'vue-i18n';
import { ServiceStatusKeyItem } from '../../types';
import { Icon } from '../../Atoms';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceStatusKeyBlock',
  props: {
    title: {},
    serviceItems: {}
  },
  setup(__props: any) {



const { t } = useI18n();

const serviceStatusKeyBlockItems = {
  title: t('Key'),
  serviceItems: [
    {
      iconName: 'statusNormal',
      heading: t('Normal service'),
      text: t('Normal service text'),
    },
    {
      iconName: 'statusAtRisk',
      heading: t('Be aware'),
      text: t('Be aware text'),
    },
    {
      iconName: 'statusDelayed',
      heading: t('Disruptions'),
      text: t('Disruptions text'),
    },
    {
      iconName: 'statusCancelled',
      heading: t('All sailings cancelled'),
      text: t('All sailings cancelled text'),
    },
  ],
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.serviceItems ? _ctx.serviceItems : serviceStatusKeyBlockItems.serviceItems), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "keyItem"
        }, [
          _createVNode(_unref(Icon), {
            "icon-name": item.iconName,
            lg: true,
            sm: false,
            md: false
          }, null, 8, ["icon-name"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h4", null, _toDisplayString(item.heading), 1),
            _createElementVNode("p", null, _toDisplayString(item.text), 1)
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})